import React from 'react';

import {Dropdown} from '@homeaway/react-dropdown';
import {SVGIcon} from '@homeaway/react-svg';
import {CHEVRON_DOWN__16, QUESTION__24} from '@homeaway/svg-defs';
import './Help.less';
import {TrackingContext} from '@homeaway/react-event-tracking';

export class Help extends React.Component {
    static contextType = TrackingContext;

    handleHelpMenuClick = (item) => {
        return () => {
            const eventFields = {
                actionlocation: `header.${item.text.replace(/\s/g, '').toLowerCase()}`
            };
            this.context.trigger('header.link.click', eventFields);

            return true;
        };
    }

    handleHelpClick = () => {
        const eventFields = {
            actionlocation: 'header.help'
        };
        this.context.trigger('header.link.click', eventFields);
    }

    renderItem = (item, index) => {
        return (
            <li key={index} role="presentation">
                <a className={item.cssClass} data-bypass="true" href={item.link} onClick={this.handleHelpMenuClick(item)} role="menuitem">{item.text}</a>
            </li>
        );
    }

    render() {
        let {items, label} = this.props;
        const id = 'site-header__help';

        if (!items) {
            return null;
        }

        const toggle = (
            <button
                aria-expanded="false"
                aria-haspopup="true"
                className="site-header-nav__toggle Dropdown__toggle"
                id={id}
            >
                <SVGIcon inlineFlex markup={QUESTION__24}/><span className="site-header-nav__icon-label">{label}</span><SVGIcon className="Dropdown__toggle-icon" inlineFlex markup={CHEVRON_DOWN__16}/>
            </button>
        );

        return (
            <Dropdown className="site-header-nav__dropdown site-header-help" customToggle={toggle} dropdownRight id={id} label={label} onDropdownShow={this.handleHelpClick}>
                {items.map(this.renderItem)}
            </Dropdown>
        );
    }
}
